<template>
    <fieldset class="">
      <legend class="" style=""> {{ translations.txtParentVenueItemsActiveInVenues }} </legend>

      <b-table-simple bordered small style="" class="m-0 text-capitalize">
        <thead>
          <tr>
            <th scope="row"> {{ translations.txtGenericVenue }} </th>
            <th scope="row"> {{ translations.txtItemActiveInVenuesIsActive }} </th>
            <th scope="row"> {{ translations.txtItemActiveInVenuesForceActive }} </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="venue in data" :key="venue.venue_id">
            <td> {{ venue.venue_title }} </td>
            <td class="text-center" >
              <wiskInput infoTooltipKey="037435d0-992f-4e7e-a65e-0035f3977733" class="d-inline-block mb-0 mt-1 p-0" style="min-height: 0;" :modelValue="venue.is_active"
                inputType="checkbox" disabled />
            </td>
            <td class="text-center" >
              <wiskInput infoTooltipKey="520a94ba-4a9f-4871-ba89-2a91d0dab28b" class="d-inline-block mb-0 mt-1 p-0" style="min-height: 0;" :modelValue="manuallyActiveByVenueId[venue.venue_id]"
                operation="active_in_venue_set" triggerInputOnLoad @update:modelValue="handleUpdate($event, venue.venue_id)" inputType="checkbox" />
            </td>
          </tr>
        </tbody>
      </b-table-simple>
    </fieldset>
  </template>

  <script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import api from '@/api'

  export default {
    name: 'ActiveInVenues',
    components: {},
    emits: ['operation'],
    props: {
      itemId: { type: Number, required: true },
      manualData: { type: Array, default: () => [] }
    },
    data() {
      return {
        data: []
      }
    },
    computed: {
      ...mapState(['translations', 'venuesHighLevelById']),
      ...mapGetters([]),
      item() {
        return this.bottlesById[this.itemId]
      },
      manuallyActiveByVenueId() {
        return this.manualData.reduce((obj, val) => {
          obj[val] = true
          return obj
        }, {})
      }
    },
    methods: {
      ...mapActions([]),
      getData() {
        api.activeItemInVenues(this.itemId)
          .then(data => {
            this.data = data.filter(venue => {
              const subscriptionStatus = this.venuesHighLevelById[venue.venue_id]?.subscription_status
              return !subscriptionStatus || subscriptionStatus === 'active'
            })
          })
      },
      handleUpdate(value, venueId) {
        let temp = this.manualData
        if (value) {
          temp.push(venueId)
        } else {
          temp = temp.filter(i => i !== venueId)
        }
        this.$emit('operation', { type: 'active_in_venue_set', value: temp })
      }
    },
    mounted() {
      this.getData()
    },
    watch: {}
  }
  </script>

  <style lang="scss">
  </style>
